export default __webpack_public_path__ + "7a752908c2de1505094ff7f8e01aae61.woff";